import Layout from "../../components/layout/Layout";
import Partners from "../../components/partners/Partners-container";
import { SeoMeta } from "@/utils/seo/SeoMeta";

const PartnersPage = () => {
  return (
    <>
      <Layout
        parent="홈"
        sub="고객사"
        pageTitle={SeoMeta.customerCompanies.title}
        pageDesc={SeoMeta.customerCompanies.description}
        pageKeyword={SeoMeta.customerCompanies.keywords}
      >
        <Partners />
      </Layout>
    </>
  );
};
export default PartnersPage;
